import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import ImpersondatePopup from './impersonate-popup/impersonate-popup';
import { consoleAPI } from '@/providers/apis/console/console';

@Component({
    name: 'impersonate-navigator',
    components: {
        'material-icon': GoogleMaterialIcon,
        'impersonate-popup': ImpersondatePopup,
    },
})

export default class ImpersonateNavigator extends Vue {

    // ------------------------------------------------------------------------
    // Properties
    /**
     * Holding the filter options
     */
    private searchBy: Array<{title: string, key: string, isActive: boolean}> = [
        {
            title: 'Email ID',
            key: 'emailId',
            isActive: true,
        },
        {
            title: 'Username',
            key: 'username',
            isActive: false,
        },
    ];

    /**
     * Help to show filter dropdown
     */
    private isShowDropDown: boolean = false;

    /**
     * Holding the search terms string
     */
    private searchTerms: string = '';

    /**
     * Help to maintain the active search
     */
    private get selectedSearch() {
        return this.searchBy.find((item) => item.isActive);
    }

    /**
     * filterParams have the filter properties
     */
    private filterParams: any = {
        offset: 0,
        limit: 10,
    };

    /**
     * userList having the list of impersonating users
     */
    private get userList() {
        return this.$store.state.impersonateStore.impersonateNavigatorUsers;
    }

    private isShowPopup: boolean = false;

    private accessToken: string = '';


    // ------------------------------------------------------------------------
    // Hooks
    private created() {
        this.$store.dispatch('impersonateStore/fetchImpersonateNavigatorUser', this.filterParams);
    }

    // ------------------------------------------------------------
    // Actions
    /**
     * Actions trigger when we click on the filter
     * @param search
     */
    private onSelectSearch(search: any) {
        this.searchBy.map((user) => user.isActive = false);
        this.$set(search, 'isActive', true);
        this.isShowDropDown = false;
    }

    private onSelectUser(userId: string) {
        consoleAPI.impersonateNavigator(userId).then((userDetails) => {
            this.accessToken = userDetails.access_token;
            this.isShowPopup = !this.isShowPopup;
        });

    }

    /**
     * Action trigger when click enter button
     * @param terms
     */
    private onSearch(terms: string) {
        const params = this.filterParams;
        const activeFilter = this.searchBy.find((filter) => filter.isActive);
        if (activeFilter) {
            params.filterBy = activeFilter.key;
            params.query = terms;
        }
        this.$store.dispatch('impersonateStore/fetchImpersonateNavigatorUser', params);
    }

    private onGoBack() {
        this.$router.push('/console');
    }
}
